import React from 'react';

const Loader = () => (
    <div className="top-loading-bar" aria-label="Loading">
        <div className="top-loading-bar__inner" />
    </div>
);

export default Loader;
